/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const SectionCreatePage = lazyLoad(
  () => import('./index'),
  module => module.SectionCreatePage
);
